import { registerApplication, start } from "single-spa";
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from "single-spa-layout";
import microfrontendLayout from "./microfrontend-layout.html";

const routes = constructRoutes(microfrontendLayout);
const applications = constructApplications({
  routes,
  loadApp({ name }) {
    return System.import(name);
  },
});
const layoutEngine = constructLayoutEngine({ routes, applications });

registerApplication({
  name: "@kpo/mf-login",
  app: () => System.import("@kpo/mf-login"),
  activeWhen: "/",
});

registerApplication({
  name: "@kpo/mf-menu",
  app: () => System.import("@kpo/mf-menu"),
  activeWhen: [
    "/home", 
    "/accesos", 
    "/perfiles", 
    "/radicacion",
    "/inconsistencias",
    "/audi-retrospectiva",
    "/bandeja",
    "/captura",
    "/tipificacion",
    "/homologacion",
    "/busqueda",
    "/informes",
    '/parametrizador',
    '/devoluciones',
    '/dashboard',
    '/recepcion'
  ],
});

registerApplication({
  name: "@kpo/mf-recepcion",
  app: () => System.import("@kpo/mf-recepcion"),
  activeWhen: "/recepcion",
});

registerApplication({
  name: "@kpo/mf-parametrizador",
  app: () => System.import("@kpo/mf-parametrizador"),
  activeWhen: "/parametrizador",
});


registerApplication({
  name: "@kpo/mf-busqueda-cuenta",
  app: () => System.import("@kpo/mf-busqueda-cuenta"),
  activeWhen: "/busqueda",
});

registerApplication({
  name: "@kpo/mf-homologacion",
  app: () => System.import("@kpo/mf-homologacion"),
  activeWhen: "/homologacion",
});

registerApplication({
  name: "@kpo/mf-accesos",
  app: () => System.import("@kpo/mf-accesos"),
  activeWhen: "/accesos",
});

registerApplication({
  name: "@kpo/mf-tipificacion",
  app: () => System.import("@kpo/mf-tipificacion"),
  activeWhen: "/tipificacion",
});

registerApplication({
  name: "@kpo/mf-informes",
  app: () => System.import("@kpo/mf-informes"),
  activeWhen: "/informes",
});


registerApplication({
  name: "@kpo/mf-captura",
  app: () => System.import("@kpo/mf-captura"),
  activeWhen: "/captura",
});

registerApplication({
  name: "@kpo/mf-radicacion",
  app: () => System.import("@kpo/mf-radicacion"),
  activeWhen: "/radicacion",
});

registerApplication({
  name: "@kpo/mf-inconsistencias",
  app: () => System.import("@kpo/mf-inconsistencias"),
  activeWhen: "/inconsistencias",
});

registerApplication({
  name: "@kpo/mf-audi-retrospectiva",
  app: () => System.import("@kpo/mf-audi-retrospectiva"),
  activeWhen: ["/audi-retrospectiva","/audi-glosar"]
});

registerApplication({
  name: "@kpo/mf-bandeja",
  app: () => System.import("@kpo/mf-bandeja"),
  activeWhen: ["/bandeja"]
});

registerApplication({
  name: "@kpo/mf-devoluciones",
  app: () => System.import("@kpo/mf-devoluciones"),
  activeWhen: ["/devoluciones"]
});

registerApplication({
  name: "@kpo/mf-dashboard",
  app: () => System.import("@kpo/mf-dashboard"),
  activeWhen: ["/dashboard"]
});





applications.forEach(registerApplication);
layoutEngine.activate();
start();

window.global = window;
